/**
 * Dashboard Page
 * Main overview of the Sales Analysis Platform
 */

import { DashboardLayout } from '@/ui/components/layouts/DashboardLayout';
import { Card } from '@/ui/components/ui/card';
import { Button } from '@/ui/components/ui/button';
import { Video, TrendingUp, Target, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DashboardPage() {
  return (
    <DashboardLayout>
      <div className="space-y-8">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-gray-600 mt-2">
            Welcome to your Sales Analysis Platform
          </p>
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="p-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                <Video size={24} className="text-purple-600" />
              </div>
              <div>
                <p className="text-sm text-gray-600">Total Recordings</p>
                <p className="text-2xl font-bold text-gray-900">0</p>
              </div>
            </div>
          </Card>

          <Card className="p-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <TrendingUp size={24} className="text-green-600" />
              </div>
              <div>
                <p className="text-sm text-gray-600">Analyzed</p>
                <p className="text-2xl font-bold text-gray-900">0</p>
              </div>
            </div>
          </Card>

          <Card className="p-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                <Target size={24} className="text-purple-600" />
              </div>
              <div>
                <p className="text-sm text-gray-600">Improvement Areas</p>
                <p className="text-2xl font-bold text-gray-900">-</p>
              </div>
            </div>
          </Card>
        </div>

        {/* Getting Started */}
        <Card className="p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Getting Started
          </h2>
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-purple-600 font-semibold">1</span>
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-gray-900">Upload a Recording</h3>
                <p className="text-gray-600 text-sm mt-1">
                  Upload your sales call audio or video files
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-purple-600 font-semibold">2</span>
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-gray-900">AI Analysis</h3>
                <p className="text-gray-600 text-sm mt-1">
                  Our AI will analyze the call and identify improvement areas
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-purple-600 font-semibold">3</span>
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-gray-900">Practice & Improve</h3>
                <p className="text-gray-600 text-sm mt-1">
                  Create custom training simulations based on real scenarios
                </p>
              </div>
            </div>
          </div>

          <Link to="/recordings">
            <Button className="gap-2 mt-6">
              Go to My Recordings
              <ArrowRight size={20} />
            </Button>
          </Link>
        </Card>
      </div>
    </DashboardLayout>
  );
}
